import React, {useState} from 'react';
import {Nav} from 'react-bootstrap';
import {BsHouseDoor, BsList, BsClipboard, BsCalendarPlus, BsPeople} from 'react-icons/bs';
import Trans from '../locales/translations';
import {AiOutlineSchedule, AiOutlineShop} from "react-icons/ai";
import {GoPeople} from "react-icons/go";
import {GrUserWorker} from "react-icons/gr";
import {LiaPeopleCarrySolid} from "react-icons/lia";

const NavbarLinks = ({activeMenuItem, handleMenuSelect, isLoggedIn}) => {
    const [openSubmenu, setOpenSubmenu] = useState(null);
    const [activeSubmenuItem, setActiveSubmenuItem] = useState(null);

    const toggleSubmenu = (submenuName) => (e) => {
        e.stopPropagation();
        setOpenSubmenu(openSubmenu === submenuName ? null : submenuName);
    };

    const handleSubmenuClick = (menuItem) => {
        handleMenuSelect(menuItem);
        setActiveSubmenuItem(menuItem);
    };

    return (
        <Nav defaultActiveKey="#dashboard" className="flex-column">
            {isLoggedIn && (
                <>
                    <Nav.Link
                        href="#dashboard"
                        active={activeMenuItem === 'dashboard'}
                        onClick={() => handleMenuSelect('dashboard')}
                    >
                        <BsHouseDoor className="me-3"/> <Trans k="navbar-links.dashboard"/>
                    </Nav.Link>

                    <Nav.Link
                        href="#orders"
                        active={activeMenuItem === 'orders'}
                        onClick={() => handleMenuSelect('orders')}
                    >
                        <AiOutlineShop className="me-3"/> <Trans k="navbar-links.orders"/>
                    </Nav.Link>
                    <Nav.Link
                        href="#customers"
                        active={activeMenuItem === 'customers'}
                        onClick={() => handleMenuSelect('customers')}
                    >
                        <GoPeople className="me-3"/> <Trans k="navbar-links.customers"/>
                    </Nav.Link>
                    <Nav.Link
                        href="#lazywa"
                        active={activeMenuItem === 'lazywa'}
                        onClick={() => handleMenuSelect('lazywa')}
                    >
                        <GoPeople className="me-3"/> LazyWa
                    </Nav.Link>
                    <Nav.Link
                        href="#items"
                        active={activeMenuItem === 'items'}
                        onClick={() => handleMenuSelect('items')}
                    >
                        <BsClipboard className="me-3"/> <Trans k="navbar-links.items"/>
                    </Nav.Link>
                    <Nav.Link
                        href="#shift-scheduler-page"
                        onClick={() => handleSubmenuClick('shift-scheduler-page')}
                    >

                        <AiOutlineSchedule className="me-3"/> <Trans k="navbar-links.shift-scheduler-page"/>
                    </Nav.Link> <Nav.Link
                    href="#employee"
                    onClick={() => handleSubmenuClick('employee')}
                    className="nav-link-text"
                >

                    <LiaPeopleCarrySolid
                        className="me-3"/> <Trans k="navbar-links.employee"/>
                </Nav.Link>


                    <div>
                        <Nav.Link
                                href="#events"
                            active={activeMenuItem === 'events'}
                            onClick={toggleSubmenu('events')}
                        >
                            <BsCalendarPlus className="me-3"/> <Trans k="navbar-links.quick-actions"/>
                        </Nav.Link>

                        {openSubmenu === 'events' && (
                            <div className="submenu">
                                <Nav.Link
                                    href="#create-order"
                                    onClick={() => handleSubmenuClick('create-order')}
                                    className={activeSubmenuItem === 'create-order' ? 'active-submenu-item' : ''}
                                >
                                    <Trans k="navbar-links.create-order"/>
                                </Nav.Link>
                                <Nav.Link
                                    href="#customer-order-form"
                                    onClick={() => handleSubmenuClick('customer-order-form')}
                                    className={activeSubmenuItem === 'customer-order-form' ? 'active-submenu-item' : ''}
                                >
                                    <Trans k="navbar-links.customer-create-order"/>
                                </Nav.Link>
                                <Nav.Link
                                    href="#create-item"
                                    onClick={() => handleSubmenuClick('create-item')}
                                    className={activeSubmenuItem === 'create-item' ? 'active-submenu-item' : ''}
                                >
                                    <Trans k="navbar-links.create-item"/>
                                </Nav.Link>
                            </div>
                        )}
                    </div>
                </>
            )}
        </Nav>
    );
};

export default NavbarLinks;
